<template lang="">
<div class="modal type2">
        <a  class="modal_close" @click="$emit('close')"></a>
        <div class="find_modal">
            <ul class="modal_tabMenu">
                <li><a  class="active">아이디 찾기</a></li>
                <li><a >비밀번호 재설정</a></li>
            </ul>
            <p class="txt">가입하신 방법에 따라 아이디 찾기가 가능합니다.</p>
            <div class="chkBox_wrap">
                <div class="chkBox">
                    <div class="chk_wrap">
                        <input type="checkbox" id="findTel" name="findTel">
                        <label for="findTel" class="chk_btn">
                            <span>휴대폰으로 찾기</span>
                        </label>
                    </div>
                </div>
                <div class="chkBox">
                    <div class="chk_wrap">
                        <input type="checkbox" id="findMail" name="findMail">
                        <label for="findMail" class="chk_btn">
                            <span>이메일로 찾기</span>
                        </label>
                    </div>
                </div>
            </div>
            <div class="modal_tabPanel" id="findTab1" >
                <div class="form_group">
                    <label>이름</label>
                    <input type="text" placeholder="이름을 입력해주세요.">
                </div>
                <div class="form_group">
                    <label>이메일</label>
                    <input type="text" placeholder="이메일 주소를 입력해주세요.">
                </div>
                <div class="btn_group">
                    <button type="button" class="btn_code">인증번호 받기</button>
                </div>
                <div class="form_group">
                    <label>인증번호</label>
                    <div class="inputBtn">
                        <input type="text" placeholder="인증번호 6자리 입력">
                        <button>재전송</button>
                    </div>
                </div>
                <div class="btn_group">
                    <button type="button" class="btn_findID">아이디 찾기</button>
                </div>
            </div>
            <div class="modal_tabPanel" id="findTab2">
                <div class="form_group">
                    <label>아이디</label>
                    <input type="text" placeholder="아이디를 입력해주세요.">
                </div>
                <div class="form_group">
                    <label>이름</label>
                    <input type="text" placeholder="이름을 입력해주세요.">
                </div>
                <div class="form_group">
                    <label>이메일</label>
                    <input type="text" placeholder="이메일 주소를 입력해주세요.">
                </div>
                <div class="btn_group">
                    <button type="button" class="btn_code">인증번호 받기</button>
                </div>
                <div class="form_group">
                    <label>인증번호</label>
                    <div class="inputBtn">
                        <input type="text" placeholder="인증번호 6자리 입력">
                        <button>재전송</button>
                    </div>
                </div>
                <div class="btn_group">
                    <button type="button" class="btn_findID">아이디 찾기</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="">
    
</style>